module.exports = __webpack_public_path__ + "static/media/sober-eye-support.1e9f0836.PNG";